import axiosInstance from "./axios";
import axios from "axios";

export const UpsertSeedDistribution = async (values = null) => {
  return await axiosInstance().post("/upsertSeedDistribution", values);
};
export const UpsertSignAndFieldMap = async (values = null) => {
  return await axiosInstance().post("/upsertSignAndFieldMap", values);
};
export const GetFarmerSignData = async (values = null) => {
  return await axiosInstance().post("/getFarmerSignData", values);
};
export const GetActiveApprovalSignByOrgCode = async (values = null) => {
  return await axiosInstance().post("/getActiveApprovalSignByOrgCode", values);
};
export const GetOrgDataForSeedDistribution = async (values = null) => {
  return await axiosInstance().post("/getOrgDataForSeedDistribution", values);
};
export const GetUserID = async (values = null) => {
  return await axiosInstance().post("/getUserID", values);
};
export const UploadSignSeedDisribution = async (values = null) => {
  return await axiosInstance().post("/uploadSignSeedDisribution", values);
};
export const GetUserDataforSeedDistribution = async (values = null) => {
  return await axiosInstance().post("/getUserDataforSeedDistribution", values);
};
export const GetAllFarmerSignDataFromSeedDestribution = async (
  values = null
) => {
  return await axiosInstance().post(
    "/getAllFarmerSignDataFromSeedDestribution",
    values
  );
};
export const GetSeedDistributionData = async (values = null) => {
  return await axiosInstance().post("/getSeedDistributionData", values);
};
export const GetFieldMapImage = async (values = null) => {
  return await axiosInstance().post("/getFieldMapImage", values);
};
export const InsertOrUpdateFieldMapImage = async (values = null) => {
  return await axiosInstance().post("/insertOrUpdateFieldMapImage", values);
};

// export const UploadSignSeedDisribution = async (values) => {
//   return await axiosInstance().post("/getUserDataforSeedDistribution' ", formData);
// };
